import React from "react";
import { CheckBoxLabel } from "../../EventCreation/styles";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Formik } from "formik";
import { FormLabel, Select, Radio } from "@material-ui/core";
import {
  CheckboxContainer,
  CustomCheckBox,
  CustomInputField,
  StyledMenuItem,
} from "../../common/FormInputs";
import { StyledSelectFormControl } from "../../common/CustomSelect/styles";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import useViewer from "../../../hooks/useViewer";
import "../Login/index.css";
import COLORS from "../../../assets/Colors";
import { navigate } from "@reach/router";

const Feedback = ({ fields, initialState, userData }) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const { userObject } = useViewer();

  const getKeys = () => {
    return { ...initialState };
  };

  function transformObject(mainObj) {
    const newMainObject = { ...mainObj };

    // Return the transformed object
    return {
      ...newMainObject,
      role: "eventviewer",
      viewerId: userObject?.id,
      eventId: userObject?.eventId,
    };
  }

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = await transformObject(values);
      const response = await EventService.eventLoginViewer(payload);
      if (response) {
        enqueueSnackbar("Login successful", {
          variant: "success",
        });
      }
      navigate("/live");
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <>
      <Background>
        <RegisterContainer className="middle-center">
          <HeadingContainer>
            <Header3>Feedback</Header3>
          </HeadingContainer>
          <Formik
            initialValues={getKeys()}
            enableReinitialize
            onSubmit={onFormSubmit}
            validationSchema={""}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              handleChange,
              resetForm,
              setFieldValue,
            }) => (
              <form>
                <Grid>
                  {fields !== null &&
                    Object.keys(fields).map((fieldName) => (
                      <div key={fieldName}>
                        <FormLabel
                          style={{
                            fontFamily: theme.fonts.primaryFontSemiBold,
                            display: userData?.event?.eventSettings
                              ?.labelsOutside
                              ? "inline"
                              : "none",
                            fontSize: 12,
                            marginTop: 10,
                            marginBottom: 10,
                            marginLeft: 10,
                          }}
                        >
                          {fieldName}
                        </FormLabel>
                        {fields[fieldName][0]?.type === "select" ? (
                          // Single dropdown for dynamic select fields
                          <div
                            className="form-fields"
                            style={{ width: "100%", marginTop: 10 }}
                          >
                            <StyledSelectFormControl variant="outlined">
                              <Select
                                as="select"
                                name={fieldName}
                                value={values[fieldName]}
                                onChange={handleChange}
                              >
                                {fields[fieldName].map((option) => (
                                  <StyledMenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </StyledMenuItem>
                                ))}
                              </Select>
                            </StyledSelectFormControl>
                          </div>
                        ) : (
                          fields[fieldName].map((field) => {
                            if (field.type === "text") {
                              return (
                                <div
                                  key={field.label}
                                  className="form-fields"
                                  style={{ width: "100%" }}
                                >
                                  <CustomInputField
                                    variant="outlined"
                                    placeholder={`${fieldName}`}
                                    value={values[fieldName]}
                                    name={fieldName}
                                    onChange={handleChange}
                                  />
                                </div>
                              );
                            } else if (field.type === "radio") {
                              return (
                                <div
                                  className="form-fields"
                                  style={{ width: "100%" }}
                                >
                                  <label>
                                    <Radio
                                      name={fieldName}
                                      type="radio"
                                      value={field.value}
                                      checked={
                                        field.value === values[fieldName]
                                      }
                                      onChange={handleChange}
                                    />
                                    <CheckBoxLabel>{field.label}</CheckBoxLabel>
                                  </label>
                                </div>
                              );
                            } else if (field.type === "checkbox") {
                              return (
                                <CheckboxContainer>
                                  <CustomCheckBox
                                    name={fieldName}
                                    value={field.value}
                                    checked={values[fieldName]?.includes(
                                      field.value,
                                    )}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const value = e.target.value;
                                      const updatedValues = checked
                                        ? [...values[fieldName], value]
                                        : values[fieldName].filter(
                                            (v) => v !== value,
                                          );
                                      setFieldValue(fieldName, updatedValues);
                                    }}
                                  />
                                  <CheckBoxLabel>{field.label}</CheckBoxLabel>
                                </CheckboxContainer>
                              );
                            }
                            return null;
                          })
                        )}
                      </div>
                    ))}
                </Grid>
                <ButtonContainer style={{ textAlign: "end" }}>
                  <PrimaryCTAButton
                    style={{
                      marginTop: "20px",
                      width: "auto",
                    }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </PrimaryCTAButton>
                </ButtonContainer>
              </form>
            )}
          </Formik>
        </RegisterContainer>
      </Background>
    </>
  );
};

export default Feedback;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    margin-top: 10px;
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  margin-bottom: 50px;
`;

export const Header3 = styled.h3`
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

const Background = styled.div`
  // background-image: linear-gradient(to bottom right, #00000022, #00000088);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
`;

const RegisterContainer = styled.div`
  position: absolute;
  width: 60%;
  overflow: auto;
  padding: 20px;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  top: 50%;
  transform: translateY(-50%);
  &.start-center {
    left: 10%;
  }
  &.middle-center {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.end-center {
    right: 10%;
  }
`;

const ButtonContainer = styled.div`
  justify-content: center;
  align-items: center;
`;
